<template>
  <div>
    <!-- Search and Table -->
    <div class="mb-3">
      <input
        type="text"
        v-model="searchQuery"
        class="form-control"
        :placeholder="$t('mundesipunesimi.kerko')"
        @input="filterTableData"
      />
    </div>




    <!-- Table or No Data Message -->
    <table class="table table-bordered" v-if="paginatedTableData.length">
      <thead>
        <tr>
          <th>{{this.$t('mundesipunesimi.data')}}</th>
          <th>{{this.$t('mundesipunesimi.titulli')}}</th>
          <th>{{this.$t('mundesipunesimi.afati')}}</th>
          <th>{{this.$t('mundesipunesimi.lloji')}}</th>
          <th>{{this.$t('mundesipunesimi.dokumenti')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in paginatedTableData" :key="index">
          <td>{{ item.data }}</td>
          <td>{{ item.titulli }}</td>
          <td>{{ item.afati }}</td>
          <td>{{ item.lloji }}</td>

        <td class="text-center align-middle">
                  <a
                    v-if="item.dokumenti && item.dokumenti !== 'No file'"
                    :href="item.dokumenti"
                    target="_blank"
                  >
                    <font-awesome-icon icon="fa-solid fa-file-pdf" />
                  </a>
                  <span v-else></span>
                </td>

        
        </tr>
      </tbody>
    </table>
    <div v-else-if="searchQuery" class="alert alert-info">
      No results found for "{{ searchQuery }}".
    </div>
    <div v-else class="alert alert-info">
      No data available.
    </div>

    <!-- Pagination Controls -->
    <div v-if="totalPages > 1" class="row mt-4">
      <div class="col-12 d-flex justify-content-center">
        <nav aria-label="Page navigation">
          <ul class="pagination">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <button class="page-link" @click="prevPage"><font-awesome-icon
                                                            icon="fa-solid fa-angle-left" /></button>
            </li>
            <li class="page-item" v-for="page in visiblePages" :key="page" :class="{ active: currentPage === page, disabled: page === '...' }">
              <button class="page-link" @click="goToPage(page)" :disabled="page === '...'">{{ page }}</button>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
              <button class="page-link" @click="nextPage"><font-awesome-icon
                                                            icon="fa-solid fa-angle-right" /></button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      searchQuery: '',
      filteredTableData: [],
      currentPage: 1,
      itemsPerPage: 8,
    };
  },
  watch: {
    tableData: {
      immediate: true,
      handler(newData) {
        this.filteredTableData = newData || []; // Initialize with tableData
        this.currentPage = 1; // Reset to first page on data change
      },
    },
  },
  computed: {
    paginatedTableData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredTableData.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredTableData.length / this.itemsPerPage) || 1;
    },
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;
      if (total <= 5) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        if (current <= 3) {
          pages.push(1, 2, 3, 4, '...', total);
        } else if (current >= total - 2) {
          pages.push(1, '...', total - 3, total - 2, total - 1, total);
        } else {
          pages.push(1, '...', current - 1, current, current + 1, '...', total);
        }
      }
      return pages;
    },
  },
  methods: {
    filterTableData() {
      const query = this.searchQuery.toLowerCase().trim();
      if (!query) {
        this.filteredTableData = this.tableData;
      } else {
        this.filteredTableData = this.tableData.filter(
          (item) =>
            item.titulli.toLowerCase().includes(query) ||
            item.lloji.toLowerCase().includes(query)
        );
      }
      this.currentPage = 1; // Reset to first page on search
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToPage(page) {
      if (typeof page === 'number' && page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
      }
    },
  },
};
</script>

<style scoped>
.form-control {
  max-width: 300px;
}
.pagination {
  margin-top: 20px;
}
.page-link {
  color: #0b0a21;
  border: 1px solid #dde3eb;
  margin: 0 5px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}
.page-link:hover {
  background-color: #dde3eb;
}
.page-item.active .page-link {
  background-color: #2c3f5e;
  color: white;
  border-color: #2c3f5e;
}
.page-item.disabled .page-link {
  color: #6c757d;
  cursor: not-allowed;
  background-color: #f8f9fa;
  border-color: #dee2e6;
}
tr th:first-child,
tr th:nth-child(3){
  width:150px;
}
tr th:nth-child(4){
  width:100px;
}

</style>